/**
 * Created by Ning Jiang on 2024-03-08.
 */

import {DeadwoodRipSymbol} from "./DeadwoodRipSymbol";
import {DeadwoodRipSymbolState} from "./DeadwoodRipSymbolConfig";
import {DeadwoodRip} from "../DeadwoodRip";
import {gsap, TimelineLite} from "gsap";
import {IS1} from "./IS1";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {DeadwoodRipReelView} from "../reels/DeadwoodRipReelView";
import {DeadwoodRipLayers, Layers} from "../view/DeadwoodRipLayers";
import {DeadwoodRipBackground} from "../view/DeadwoodRipBackground";
import {MathHelper} from "../../core/utils/MathHelper";

export class RetriggerS1Symbol extends DeadwoodRipSymbol implements IS1 {

    constructor(reelId:number, initState:DeadwoodRipSymbolState) {
        super("S1", reelId, initState);
    }

    public playOnShot():TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            Logger.logDev(`I am ${this._itemName}, I play on shot!`);
        });
        return tl;
    }

    public split(type:number, noWin:boolean):TimelineLite {
        return new TimelineLite();
    }

    protected getStateTexture(state?:DeadwoodRipSymbolState):PIXI.Texture[] {
        let texturePath = `${this.symbolName}/${this.symbolName}`;

        texturePath += this.getReelExtension();

        if(state === DeadwoodRipSymbolState.SPIN) {
            texturePath += `_${state}`;
        }
        return DeadwoodRip.assetLoader.getTextures(texturePath);
    }

    protected getOnShotAnimationName():string {
        return `S1_Shoot`;
    }

    protected getKillAnimationName():string {
        return `S1${this.getReelExtension()}Dead`;
    }

    protected getDeadLoopAnimationName():string {
        return `S1${this.getReelExtension()}DeadLoop`;
    }

    protected getCharacterAssetName():string {
        return "S1_FS";
    }

    public playNormalLanding(amount:number):TimelineLite {
        this.createDeadContainer();
        const aniName = `S1${this.getReelExtension()}Landing`;
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(1, aniName, false);
            DeadwoodRipSound.playS1FSLand(amount, this.reelId);
        });
        tl.add(() => {
            this._deadCharacter.state.setAnimation(1, aniName, false).trackTime = this._deadCharacter.spineData.findAnimation(aniName).duration;
        }, `+=${this._deadCharacter.spineData.findAnimation(aniName).duration}`);
        this._parts.forEach(p => {
            tl.add(gsap.to(p, {alpha : 0, duration : 0.2}), 0);
        });
        return tl;
    }

    public playNearWinLoop():void {
        this.createDeadContainer();
        this._deadCharacter.visible = true;
        this._deadCharacter.state.setAnimation(1, `S1${this.getReelExtension()}AttentionLoop`, true);
    }

    public playWin(isLanding:boolean):TimelineLite {
        this.createDeadContainer();
        const aniName = `S1${this.getReelExtension()}Landing`;
        const tl = new TimelineLite();
        tl.add(() => {
            this._deadCharacter.visible = true;
            this._deadCharacter.state.setAnimation(1, aniName, false);
        });
        tl.add(() => {
        }, `+=${this._deadCharacter.spineData.findAnimation(aniName).duration}`);

        if(isLanding) {
            const glow = new PIXI.spine.Spine(DeadwoodRip.assetLoader.getSpineAsset("S1"));
            glow.autoUpdate = true;
            glow.position.set(DeadwoodRipReelView.REEL_AREAS[this.reelId].x, DeadwoodRipReelView.REEL_AREAS[this.reelId].y + DeadwoodRipSymbol.DEFAULT_HEIGHT * (DeadwoodRip.model.parsedGameData.S1Positions[this.reelId] + 0.5));
            tl.add([
                () => {
                    DeadwoodRipLayers.getLayer(Layers.WIN_PRESENTATIONS)!.addChild(glow);
                    glow.state.setAnimation(0, "S1Glow", false);
                    DeadwoodRipBackground.shakeStageOnce(0.3);
                }
            ], 0);
            tl.add(() => {
                DeadwoodRipLayers.getLayer(Layers.WIN_PRESENTATIONS)!.removeChild(glow);
                glow.state.setEmptyAnimations(0);
                glow.destroy();
            });
        }
        return tl;
    }

    public playRetrigger():TimelineLite {
        this.createDeadContainer();
        const amount = MathHelper.randomNumberInRange(2, 5);
        const tl = new TimelineLite();
        let delay = 0;
        for(let i = 0; i < amount; i++) {
            tl.add(this.playRetriggerOnShot(), delay);
            delay += Math.random() * 0.2;
        }
        return tl;
    }

    public playRetriggerOnShot():TimelineLite {
        const aniName = `S1${this.getReelExtension()}Win`;
        const tl = new TimelineLite();
        tl.add([
            () => {
                this._deadCharacter.visible = true;
                this._deadCharacter.state.setAnimation(1, aniName, false);
                DeadwoodRipBackground.shakeStageOnce(0.3);
            },
            this.shotAtRandomPosition(true, false)
        ]);
        tl.add(() => {
        }, `+=${this._deadCharacter.spineData.findAnimation(aniName).duration}`);

        return tl;
    }

    private getReelExtension():string {
        switch(this.reelId) {
            case 1:
                return "_R";
            case 2:
                return "_I";
            case 3:
                return "_P";
            default:
                debugger;
                return "";
        }
    }
}